export const languages = [
  { key: "en", label: "English" },
  { key: "ar", label: "Arabic" },
  { key: "fr", label: "French" },
  { key: "es", label: "Spanish" },
];
